import ai4iLogo from "../assets/ai4i.jpeg";
import uninaLogo from "../assets/unina.jpeg";
import spiciLogo from "../assets/spici.jpeg";
import sabaLogo from "../assets/saba.png";
import { FiBriefcase } from "react-icons/fi";

const experiences = [
  {
    title: "Research Engineer - AI & Robotics",
    company: "The Italian Institute of Artificial Intelligence (AI4I)",
    dates: "Currently Working",
    location: "Turin, Italy",
    logo: ai4iLogo,
    url: "https://ai4i.it/",
  },
  {
    title: "Artificial Intelligence Researcher",
    company: "Università degli Studi di Napoli Federico II",
    dates: "May 2024 - Sep 2026",
    location: "Naples, Italy",
    logo: uninaLogo,
    url: "https://www.magic.unina.it/",
  },
  {
    title: "Data Scientist",
    company: "SPICI srl",
    dates: "Jan 2022 - Aug 2022",
    location: "Naples, Italy",
    logo: spiciLogo,
    url: "https://spici.eu/",
  },
  {
    title: "Network Engineer",
    company: "Saba Power and Water Investment Company",
    dates: "Jun 2018 - Nov 2020",
    location: "Tehran, Iran",
    logo: sabaLogo,
    url: "",
  },
];

function Experience() {
  return (
    <section id="experience" className="section-shell">
      <div className="section-heading">
        <p className="section-title">Experiences</p>
        <span className="section-icon" aria-hidden="true"><FiBriefcase /></span>
      </div>

      <div className="timeline">
        {experiences.map(experience => (
          <article key={experience.title} className="timeline-item">
            <span className="timeline-marker" />
            {(() => {
              const Card = experience.url ? "a" : "div";
              const cardProps = experience.url
                ? { href: experience.url, target: "_blank", rel: "noopener noreferrer" }
                : {};

              return (
                <Card
                  {...cardProps}
                  className="experience-card panel group block rounded-lg"
                >
              <div className="flex items-start gap-3">
                {experience.logo && (
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white p-1">
                    <img src={experience.logo} alt="" width="40" height="40" loading="lazy" decoding="async" className="h-full w-full object-contain" />
                  </div>
                )}
                <div className="min-w-0 flex-1">
                  <span className="experience-title inline-flex items-start gap-2 text-base font-semibold leading-snug text-zinc-100 group-hover:text-white">
                    {experience.title}
                    {experience.url && (
                      <svg className="experience-external-icon mt-0.5 h-3.5 w-3.5 shrink-0 text-zinc-600 transition-colors group-hover:text-[var(--accent)]" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 17L17 7M7 7h10v10" />
                      </svg>
                    )}
                  </span>
                  <div className="mt-1 flex flex-wrap items-baseline gap-x-1 gap-y-1 text-sm">
                    <span className="text-zinc-400 group-hover:text-zinc-100 transition-colors">{experience.company}</span>
                    <span className="whitespace-nowrap text-zinc-500"> - {experience.dates}</span>
                    {experience.location && <span className="text-zinc-500"> · {experience.location}</span>}
                  </div>
                </div>
              </div>
                </Card>
              );
            })()}
          </article>
        ))}
      </div>
    </section>
  );
}

export default Experience;
